import { formatCurrency } from '@/common/utils/formatters'
import { consumptionStatusTranslation } from '@/features/establishmentLeadsFunnel/constants/consumptionStatus.constants'
import { EstablishmentLeadData } from '@/features/establishmentLeadsFunnel/types/establishmentLead.type'

export class ConsumptionsTransformer {
  static tableTransformer() {
    return (
      first_complete_consumption_per_capture_method: EstablishmentLeadData['first_complete_consumption_per_capture_method'],
    ) => {
      return first_complete_consumption_per_capture_method.map((consumption) => ({
        status:
          consumptionStatusTranslation[(consumption?.status || 'default') as keyof typeof consumptionStatusTranslation],
        protocol_number: consumption?.protocol_number || 'Não informado',
        capture_method: consumption?.capture_method.display_name || 'Não informado',
        total_amount: consumption?.total_amount
          ? formatCurrency(parseFloat(consumption?.total_amount))
          : 'Não informado',
        card_last_four_digits: consumption?.card_last_four_digits
          ? `**** **** **** ${consumption?.card_last_four_digits}`
          : 'Não informado',
      }))
    }
  }
}
